import { render, staticRenderFns } from "./Evrimed.vue?vue&type=template&id=471f4b8c&scoped=true"
import script from "./Evrimed.vue?vue&type=script&lang=js"
export * from "./Evrimed.vue?vue&type=script&lang=js"
import style0 from "./Evrimed.vue?vue&type=style&index=0&id=471f4b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f4b8c",
  null
  
)

export default component.exports